<template>
  <p style="width: 400px">Etkinlik henüz aktif değildir.</p>
</template>

<script>
export default {};
</script>

<style>
</style>